import { __require as r } from "../../../dompurify@3.2.6/bundled_deps/dompurify/dist/purify.cjs.js";
var e = window.DOMPurify || (window.DOMPurify = r().default || r());
export {
  e as b
};
